import React from 'react';

export default function Button(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <button {...props} className={`py-2 px-4 rounded border-0 cursor-pointer ${props.className}`}>
            {props.children}
        </button>
    )
}